import { ChangeEvent, useState } from 'react'
import { Box, SxProps } from '@mui/material'
import classNames from 'classnames'
import { useField } from 'formik'

import RenderDocumentIcon from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/RenderDocumentIcon'
import { DocumentosPermitidos } from 'src/enums/EscritosLegales'
import useInputFileNew from 'src/hooks/useInputFileNew'
import { theme } from 'src/providers/ThemeProvider'
import { UploadIcon } from '../../Icons'
import InfoBar from '../../InfoBar/InfoBar'

type InputFileStylesType = {
  wrapperInput: SxProps
  upload: SxProps
  nameFile: SxProps
  wrapperErrors: SxProps
}

const styles: InputFileStylesType = {
  wrapperInput: {
    height: 118,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    border: `0.5px dashed ${theme.colors.gray16}`,
    background: theme.colors.gray50,
    marginBottom: theme.spacing(2),

    '&.error': {
      borderColor: theme.colors.red01,
      background: theme.colors.persianRed050
    },

    '&:not(.error).filled': {
      height: 'auto',
      border: 'none',
      background: theme.colors.white01,
      justifyContent: 'flex-start'
    }
  },

  upload: {
    marginBottom: '8px'
  },

  nameFile: {
    color: theme.colors.main900,
    marginLeft: '8px'
  },

  wrapperErrors: {
    marginBottom: theme.spacing(2)
  }
}

type Props = {
  id: string
  required?: boolean
  multiple?: boolean
  disabled?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

function InputFile({
  id,
  required = false,
  multiple = false,
  disabled = false,
  onChange = () => null
}: Props): JSX.Element {
  const [_fieldInfo, meta] = useField(id)

  const [fileInputRef, setFileInputRef] = useState<any>()

  const inputClassNames = classNames({
    required,
    error: meta.error,
    filled: fileInputRef?.value !== ''
  })

  const { setInputFile, clearInputFile, errorsValidation } = useInputFileNew({
    id,
    multiple
  })

  async function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files && event.target.files[0]) {
      setInputFile(event.target.files[0])
    } else {
      clearInputFile()
      fileInputRef.value = ''
    }

    onChange(event)
  }

  // useEffect(
  //   () => {
  //     if (errors[id] && errors[id] !== '') {
  //       addAlert({
  //         message: errors[id],
  //         type: AlertType.ERROR,
  //         closeAction: closeWarning
  //       })
  //     }
  //   },
  //   // eslint-disable-next-line
  //   [errors[id]]
  // )

  return (
    <Box>
      {errorsValidation.map(error => (
        <Box key={`error_${error.message}`} sx={styles.wrapperErrors}>
          <InfoBar message={error.message} type={error.type} />
        </Box>
      ))}

      <Box sx={styles.wrapperInput} className={inputClassNames}>
        <input
          id={id}
          style={{ display: 'none' }}
          ref={ref => {
            setFileInputRef(ref)
          }}
          type="file"
          accept={multiple ? DocumentosPermitidos.ANEXOS : DocumentosPermitidos.PRINCIPAL}
          onChange={handleChange}
          disabled={disabled}
          required={required}
        />
        {_fieldInfo?.value && _fieldInfo?.value?.file ? (
          <label htmlFor={id}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <RenderDocumentIcon file={_fieldInfo.value.file.name} multiple={false} />
              <Box component="span" sx={styles.nameFile}>
                {_fieldInfo.value.file.name}
              </Box>
            </Box>
          </label>
        ) : (
          <label htmlFor={id}>
            <Box display="flex" alignItems="center" justifyContent="center" sx={styles.upload}>
              <UploadIcon htmlColor={theme.corporate.primaryColor} sx={{ fontSize: '26px' }} />
            </Box>
            Seleccionar documento
          </label>
        )}
      </Box>
    </Box>
  )
}

export default InputFile
